/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import MaterialTable, { EditComponentProps, MTableToolbar } from 'material-table';
import { 
    Avatar, 
    ListItem, 
    ListItemAvatar, 
    ListItemText, 
    Badge,
    Typography, 
    Chip,
    Checkbox
} from '@material-ui/core';
import { Colors, hashString } from '../../tasksSummary/board/BoardCardDraggable';
import { AvatarColorName } from '../../types/AvatarColorName';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import { browserHistory } from '../../components/AppContent';
import { showNotification } from '../../App';
import { Icons } from 'material-table';
import { forwardRef } from 'react';
 
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { client } from '../..';
import gql from 'graphql-tag';
import DialogBox from '../../Dashboard/Component/DialogBox';
import { useStyles } from '../../lookupConfiguration/common/tabsStyle';
import { FirmData, Team } from '../../lookupConfiguration/models/Firm';
import { retrieveTeamData } from '../../lookupConfiguration/selectors/FirmTeamSelector';
import CheckIcon from '@material-ui/icons/Check';

interface LookupTeamsMaintenanceState {
    // tslint:disable-next-line: no-any
    selectedRow: any | null;
    data: Team[];
    isLoading: boolean;
}

// tslint:disable-next-line: no-any
let onDeleteItems: any = [];

export default function LookupTeamsMaintenance() {

    const classes = useStyles();

    const [state, setState] = useState<LookupTeamsMaintenanceState>({
        selectedRow: null,
        data: [],
        isLoading: false,
    });

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    useEffect(() => {   
        fetchData();

        const subscribeFirmObj = subscribeFirm();

        return () => {
            subscribeFirmObj.unsubscribe();
        };
    // tslint:disable-next-line: align
    }, []);

    const tableIcons: Icons = {
        Add: forwardRef((props, ref) => <AddBox {...props} ref={ref}  className="check-button" />),
        Check: forwardRef((props, ref) => <Check {...props} ref={ref}  className="check-button" />),
        Clear: forwardRef((props, ref) => <Clear {...props} ref={ref}  className="check-button" />),
        Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref}  className="check-button" />),
        DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref}  className="check-button" />),
        Edit: forwardRef((props, ref) => <Edit {...props} ref={ref}  className="check-button" />),
        Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref}  className="check-button" />),
        Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref}  className="check-button" />),
        FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref}  className="check-button" />),
        LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref}  className="check-button" />),
        NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref}  className="check-button" />),
        PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref}  className="check-button" />),
        ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref}  className="check-button" />),
        Search: forwardRef((props, ref) => <Search {...props} ref={ref}  className="check-button" />),
        SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
        ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref}  className="check-button" />),
        ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref}  className="check-button" />)
    };

    const subscribeFirm = () => {
        return (
            // let subscription =
            client
                .subscribe({
                    fetchPolicy: 'no-cache',
                    query: firmSubscription,
                    variables: {},
                })
                .subscribe({
                    // tslint:disable-next-line:no-any
                    next(results: any) {
                        if (results.data.lookupNotification.status) {

                            const { lookupNotification } = results.data;
                            showNotification('Success', lookupNotification.message, 'info');

                            if (lookupNotification.message.includes('created successfully')) {
                                setState((prevState) => {

                                    const tdata = [...prevState.data];

                                    const temp = tdata[tdata.length - 1];

                                    tdata[tdata.length - 1] = {
                                        ...temp,
                                        guidID: lookupNotification.guidId
                                    };

                                    return {
                                        ...prevState,
                                        data: tdata
                                    };
                                });
                            }

                        } else {
                            showNotification('Failed', results.data.lookupNotification.message, 'error');
                        }
                    },
                    // tslint:disable-next-line:no-any
                    error(err: any) {
                        // tslint:disable-next-line:no-console
                        console.error(err);
                        showNotification(null, err, 'error');
                    },
                })
        );
    };

    const fetchData = () => {

        setState({
            ...state,
            isLoading: true,
        });
        retrieveTeamData(
            undefined,
            true, // this.state.isRefresh, -- Since we are updating and creating, we do not fetch cached data
            // tslint:disable-next-line: no-console
            (data) => onRetrieveData(data),
            // tslint:disable-next-line:no-any
            function (reason: any): void {
                showNotification(null, reason, 'error');
            }
        );
    };

    const onRetrieveData = (data: FirmData) => {
        
        setState({
            ...state,
            data: data.firm.teams.team,
            isLoading: false
        });
    };

    // tslint:disable-next-line: no-any
    const getSection = (data: any) => {

        const { description } = data;

        let bColor: AvatarColorName = Colors[(description === '' || description === null) ? 
        Colors[Colors.length] : (hashString(description) % Colors.length) - 1];
        let stringSplit = description
        .replace(/[^\w\s]/gi, '') // remove special character
        .split(' ')
        // tslint:disable-next-line: no-any
        .map((n: any) => n[0])
        .join('');

        let stringInitials = stringSplit.slice(0, 2);
        
        return (
            <div>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar
                            style={{ backgroundColor: bColor ? bColor : 'grey', color: '#fff' }}
                            className={classes.avatar}
                        >
                            {stringInitials}
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={description} />
                </ListItem>
            </div>
        );
    };

    // tslint:disable-next-line: no-any
    const getMember = (data: any) => {

        let staffCount = 0;

        if (data) {
            staffCount = data.staffCount;
        }

        return (
            <div>
                <Badge color="primary" badgeContent={staffCount}>
                    <PeopleOutlineIcon />
                </Badge>
            </div>
        );
    };

    // tslint:disable-next-line: no-any
    const getCheckboxRender = (data: any, field: string) => {

        if (data && data[field]) {
            return  (
                <CheckIcon className={classes.checkIcon} />
            );
        }

        return undefined;
    };

    // tslint:disable-next-line: no-any
    const checkBoxComponent = (componentProps: EditComponentProps<any> | any) => {
        return (
            <>
                <Checkbox
                    checked={componentProps.value}
                    // tslint:disable-next-line: no-any
                    onChange={(event: any) => componentProps.onChange(event.target.checked)}
                />
            </>
        );
    };

    // tslint:disable-next-line: no-any
    const handleRowClick = (event?: React.MouseEvent, rowData?: any, toggleDetailPanel?: (panelIndex?: number) => void) => {

        setState({
            ...state,
            selectedRow: rowData.tableData.id
        });

        browserHistory.push(`/firmStructureConfiguration/teams/${encodeURIComponent(rowData.description)};key=${rowData.guidID}`);
    };

    const updateRowData = (newData: Team, oldData: Team) => {

        setState((prevState) => {

            const tdata = [...prevState.data];
            
            // const isExists = tdata.filter((item: Team) => item.description.toLowerCase().includes(newData.description.toLowerCase())).length;
            
            tdata[tdata.indexOf(oldData)] = newData;

            return { 
                ...prevState, 
                data: tdata
            };
            
        });
    };

    const updateData = (rowData: Team) => {

        if (rowData) {
            client
                .mutate({
                    mutation: updateFirmTeam,
                    variables: {
                        guidId: rowData.guidID,
                        description: rowData.description,
                        usedByTasks: rowData.usedByTasks,
                        usedByFinancials: rowData.usedByFinancials,
                        usedByEnquiries: rowData.usedByEnquiries
                    },
                })
                // tslint:disable-next-line: no-any
                .then((results: { data: any }) => {
                    if (results.data) {
                        if (results.data.error !== undefined) {
                            showNotification( 'Failed to Update Team', results.data.error, 'error');
                        }
                    }
                })
                // tslint:disable-next-line:no-any
                .catch((reason: any) => {
                    showNotification('Failed to Update Team', reason, 'error');
                });
        }
    };

    const deleteRowData = (oldData: Team) => {

        setState((prevState) => {
            const tdata = [...prevState.data];
            tdata.splice(tdata.indexOf(oldData), 1);
            return { 
                ...prevState, 
                data: tdata 
            };
        });
        
    };

    const deleteData = (oldData: Team) => {
        client
            .mutate({
                mutation: deleteFirmTeam,
                variables: {
                    guidId: oldData.guidID,
                },
            })
            // tslint:disable-next-line: no-any
            .then((results: { data: any }) => {
                if (results.data) {
                    if (results.data.error !== undefined) {
                        showNotification( 'Failed to Delete Team', results.data.error, 'error');
                    }
                }
            })
            // tslint:disable-next-line:no-any
            .catch((reason: any) => {
                showNotification('Failed to Delete Team', reason, 'error');
            });
    };

    // tslint:disable-next-line: no-any
    const insertRowData = (newData: Team) => {

        setState((prevState) => {

            const tdata = prevState.data;

            const isExists = tdata.filter((item: Team) => item.description.toLowerCase().includes(newData.description.toLowerCase())).length;

            if (!isExists) {
                tdata.push(newData);
            }

            return {    
                ...prevState,
                data: tdata
            };

        });
    };

    // tslint:disable-next-line: no-any
    const createData = (newData: Team) => {
        if (newData) {
            client
                .mutate({
                    mutation: createFirmTeam,
                    variables: {
                        description: newData.description,
                        usedByTasks: newData.usedByTasks,
                        usedByFinancials: newData.usedByFinancials,
                        usedByEnquiries: newData.usedByEnquiries
                    },
                })
                // tslint:disable-next-line: no-any
                .then((results: { data: any }) => {
                    if (results.data) {
                        if (results.data.error !== undefined) {
                            showNotification( 'Failed to Create Team', results.data.error, 'error');
                        }
                    }
                })
                // tslint:disable-next-line:no-any
                .catch((reason: any) => {
                    showNotification('Failed to Create Team', reason, 'error');
                });
        }
    };

    // tslint:disable-next-line: no-any
    const onDeleteData = (data: any) => {

        setShowDeleteConfirm(true);

        onDeleteItems = data;

    };

    const onDeleteConfirm = (agree: boolean) => {
        if (agree) {
            // tslint:disable-next-line: no-any
            onDeleteItems.forEach((selected: any) => {

                // delete check data
                deleteData(selected);

                setState((prevState) => {
                    const tdata = [...prevState.data];
                    tdata.splice(tdata.indexOf(selected), 1);
                    return { 
                        ...prevState, 
                        data: tdata 
                    };
                });

            });
        }

        setShowDeleteConfirm(false);
    };

    const getTitle = (title: string, count: number) => {
        return (
            <div className={classes.tableTitle}>
                <Typography className={classes.tableHeading}>{title}</Typography>
                <Chip className={classes.chip} label={count} />
            </div>
        );
    };

    return (
        <div className={classes.root}>
            <DialogBox
                title="Teams"
                // tslint:disable-next-line:max-line-length
                content={`Are you sure you want to delete the selected row?`}
                show={showDeleteConfirm}
                isAgree={onDeleteConfirm}
                disAgreeLabel={'No'}
                agreeLabel={'Yes'}
                className={classes.dialogBox}
            />
            <MaterialTable
                isLoading={state.isLoading}
                title={getTitle('Teams', state.data.length)}
                icons={tableIcons}
                onRowClick={handleRowClick}
                columns={[
                    // tslint:disable-next-line: max-line-length
                    { 
                        title: 'Teams', 
                        field: 'description', 
                        render: (rowData) => getSection(rowData), 
                        cellStyle: { flex: 3 }, 
                        headerStyle: { flex: 3 },
                        validate: (rowData) => rowData.hasOwnProperty('description') && rowData.description 
                            ? true 
                            : { isValid: false, helperText: 'Team is required'}, 
                    },
                    {
                        title: 'Used By Enquiries',
                        field: 'usedByEnquiries',
                        render: (rowData) => getCheckboxRender(rowData, 'usedByEnquiries'),
                        editComponent: (componentData) => checkBoxComponent(componentData)
                    },
                    {
                        title: 'Used By Tasks',
                        field: 'usedByTasks',
                        render: (rowData) => getCheckboxRender(rowData, 'usedByTasks'),
                        editComponent: (componentData) => checkBoxComponent(componentData)
                    },
                    {
                        title: 'Used By Financials',
                        field: 'usedByFinancials',
                        render: (rowData) => getCheckboxRender(rowData, 'usedByFinancials'),
                        editComponent: (componentData) => checkBoxComponent(componentData)
                    },
                    // tslint:disable-next-line: max-line-length
                    { title: 'Members Count', field: 'staffCount', render: (rowData) => getMember(rowData), editable: 'never', cellStyle: { justifyContent: 'center' }, headerStyle: { justifyContent: 'center' } },
                ]}
                components={
                    {
                        Toolbar: props => (
                            <div className={classes.customToolbar}>
                                <MTableToolbar classes={{ highlight: classes.highlight, actions: classes.actions }} {...props} />
                            </div>
                        )
                    }
                }
                data={state.data}        
                options={{
                    addRowPosition: 'first',
                    search: true,
                    selection: true,
                    paging: true,
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 30, 40, 50],
                    showTitle: true,
                    toolbar: true,
                    actionsColumnIndex: -1,
                    rowStyle: rowData => ({
                        backgroundColor: (state.selectedRow === rowData.tableData.id) ? '#EEE' : '#FFF'
                    })
                }}
                editable={{
                    onRowAdd: (newData: Team) =>
                        // tslint:disable-next-line: no-any
                        new Promise((resolve: any) => {
                            setTimeout(() => {
                                resolve();
                                if (newData.description) {
                                    createData(newData);
                                    insertRowData(newData);
                                }
                            // tslint:disable-next-line: align
                            }, 600);
                        }),
                    onRowUpdate: (newData, oldData) =>
                        // tslint:disable-next-line: no-any
                        new Promise((resolve: any) => {
                            setTimeout(() => {
                            resolve();
                            if (oldData) {
                                updateData(newData);
                                updateRowData(newData, oldData);
                            }
                            // tslint:disable-next-line: align
                            }, 600);
                        }),
                    onRowDelete: (oldData) =>
                        // tslint:disable-next-line: no-any
                        new Promise((resolve: any) => {
                            setTimeout(() => {
                                resolve();
                                if (oldData) {
                                    deleteData(oldData);
                                    deleteRowData(oldData);
                                }
                            // tslint:disable-next-line: align
                            }, 600);
                        }),
                }}
                actions={[
                    {
                        tooltip: 'Remove All Selected Team',
                        icon: DeleteOutline,
                        // tslint:disable-next-line: no-any
                        onClick: (evt: any, data: any) => onDeleteData(data)
                    },
                ]}
            />
        </div>
    );
}

const createFirmTeam = gql`
    mutation createFirmTeam($description: String, $usedByTasks: Boolean, $usedByFinancials: Boolean, $usedByEnquiries: Boolean) {
        createFirmTeam(description: $description, usedByTasks: $usedByTasks, usedByFinancials: $usedByFinancials, usedByEnquiries: $usedByEnquiries)
    }
`;

const updateFirmTeam = gql`
    mutation updateFirmTeam($description: String, $guidId: String, $usedByTasks: Boolean, $usedByFinancials: Boolean, $usedByEnquiries: Boolean) {
        updateFirmTeam(description:$description, guidId: $guidId, usedByTasks: $usedByTasks, usedByFinancials: $usedByFinancials, usedByEnquiries: $usedByEnquiries)
    }
`;

const deleteFirmTeam = gql`
    mutation deleteFirmTeam($guidId: String) {
        deleteFirmTeam(guidId: $guidId)
    }  
`;

export const firmSubscription = gql`
    subscription firm{
        lookupNotification{
            id,
            guidId,
            lookupDescription,
            message,
            status
        }
    }
`;